import { QRCode } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppModal } from '@components/form/Modal';
import { useSupportChat } from '@shared/hooks/use-support-chat';

type Props = {
  open: boolean;
  closeModal: VoidFunction;
  sessionUrl?: string | null;
};

function KYCModal({ open, closeModal, sessionUrl }: Props) {
  const { openSupportChat } = useSupportChat();
  const { t } = useTranslation();

  return (
    <AppModal
      width={450}
      title={t('verify_kyc')}
      open={open}
      onCancel={closeModal}
      footer={
        <AppModal.Footer>
          <AppModal.Button className="w-full capitalize!" onClick={closeModal}>
            {t('cancel')}
          </AppModal.Button>
          <AppModal.Button
            type="primary"
            className="w-full bg-red-600! text-white! capitalize!"
            htmlType="submit"
            onClick={() => {
              closeModal();
              openSupportChat();
            }}
          >
            {t('contact_support')}
          </AppModal.Button>
        </AppModal.Footer>
      }
    >
      <div className="flex flex-col gap-6">
        <p className="text-text-500 text-sm pr-15">
          {t('account_not_yet_verified_please_complete_kyc_verification_to_unlock_full_access')}
        </p>
        <div className="bg-gray-light py-5 px-2.5 rounded-lg border border-gray-200 flex flex-col items-center">
          {sessionUrl ? (
            <QRCode value={sessionUrl} color="black" className="[.ant-qrcode]:border-none!" />
          ) : (
            <QRCode value="placeholder" color="black" className="[.ant-qrcode]:border-none! opacity-20!" />
          )}
          <div className="text-center mt-2">
            <p className="text-sm">{t('scan_the_code_to_begin_verification_on_another_device')}</p>
            <p className="text-text-500 text-sm">{t('didit_scan_will_be_used_to_verify_your_identity')}</p>
          </div>
          {sessionUrl && (
            <Link to={sessionUrl} target="_blank" rel="noopener noreferrer" className="text-sm break-all text-center">
              {sessionUrl}
            </Link>
          )}
        </div>
      </div>
    </AppModal>
  );
}

export default KYCModal;
